import { motion, useSpring, useScroll } from "motion/react";
import { Header } from './container/Header';
import { HomeSection } from './container/Home';
import { ProjectsSection } from './container/Projects';
import { Services } from './container/Services';
import References from "./container/References";
import Footer from './container/Footer';

export default function App() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001,
    });

    return (
        <div className="text-black antialiased" style={{
            background: "linear-gradient(217deg, white, #ffffff 70.71%), linear-gradient(127deg, #fff, #e8e8e894 70.71%), linear-gradient(336deg, #ffffffc8, #e8e8e8 70.71%)"
        }}>
            <motion.div
                id="scroll-indicator"
                style={{
                    scaleX,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 10,
                    originX: 0,
                    backgroundColor: "#879b9cc1",
                    zIndex: 9999,
                    borderRadius: "15px",
                }}
            />
            <div>
                <Header />
                <div id="home">
                    <HomeSection />
                </div>
                <div id="about Us">
                    <ProjectsSection />
                </div>
                <div id="solutions">
                    <Services />
                </div>
                <div id="references">
                    <References />
                </div>
                <div id="contact">
                    <Footer />
                </div>
            </div>
        </div>
    );
}